var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playback-details"
  }, [_c('a', {
    on: {
      "click": _vm.expandToggle
    }
  }, [(_vm.expanded) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.titleText(_vm.playback))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "has-text-grey-light is-pulled-right"
  }, [_vm._v(_vm._s(_vm.playback.type) + "\n        "), _vm._m(0)]), _vm._v(" "), (_vm.playback.url) ? _c('playback-embed', {
    attrs: {
      "playback": _vm.playback
    }
  }) : _c('h4', [_vm._v("Nothing to display")]), _vm._v(" "), _c('div', {
    staticClass: "playback-details__content content"
  }, [(_vm.playback.caption) ? _c('div', {
    staticClass: "playback-details__caption",
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.playback.caption))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.playback.caption && _vm.playback.tombstone) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.playback.tombstone) ? _c('div', {
    staticClass: "playback-details__tombstone is-size-7",
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.playback.tombstone))
    }
  }) : _vm._e()])], 1) : _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.titleText(_vm.playback))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "has-text-grey-light is-pulled-right"
  }, [_vm._v(_vm._s(_vm.playback.type) + "\n        "), _vm._m(1)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-ios-arrow-up"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-ios-arrow-down"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-689b5eb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlaybackDetails.vue
// module id = ji5e
// module chunks = 0